<script src="https://www.google.com/recaptcha/api.js" async defer></script>

<script>
import Layout from "../../layouts/main";
import PlaneApi from "@/services/plane-api";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import vue2Dropzone from "vue2-dropzone";
import appConfig from "@/app.config";


export default {
  page: {
    title: "Remplir votre Demande de Devis",
    meta: [{ name: "description", content: appConfig.description }]
  },
  name: 'Request-estimate',
  components: {Layout, FormWizard, TabContent, WizardStep, vue2Dropzone},
  data() {
    return {

      isFinishDisabled: false,

      plane:null,
      planeDTO:null,
      requestQuote:{
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        companyName: null,
        sectorActivity: null,
        address: null,
        customDuration:null,
        campaignDate:null,
        quantityBags:null
      },

      options:{
        classic:[
          {
            image:"pharma-bags",
            title:"sac pharmacie",
          },
          {
            image:"bakery-bags",
            title:"sac à pain",
            description:"Différents formats de sacs,\n(1 à 2 baguettes) ou (3 à 4 baguettes)."
          },

        ],
        prime:[
          {
            image:"pharma-bags-prime",
            title:"sac pharmacie",
          },
          {
            image:"bakery-bags-prime",
            title:"sac à pain",
            description:"Différents formats de sacs,\n(1 à 2 baguettes) ou (3 à 4 baguettes)."
          },
        ]

      },
      selectedOptions:{
        classic:null,
        prime:null
      },
      selectedSizeBags:null,

      sizeBags:[
        {
          size:"11x5x36",
          description:"1 à 2 baguettes",
          image:"",
          index:0

        },
        {
          size:"15x7x36",
          description:"3 à 4 baguettes",
          image:"",
          index:1

        }
      ],

      sizeBagsPharmacy:[
        {
          size:"Petit",
          description:"",
          image:"",
          index:2

        },
        {
          size:"Moyen ",
          description:"",
          image:"",
          index:3

        },
        {
          size:"Grand  ",
          description:"",
          image:"",
          index:4

        }
      ],

      bagsColor:["1","2","3","4"],
      selectedBagsColor:null,
      campaignDuration:["2", "3", "4", "+"],
      selectedCampaignDuration:null,

      showClassic:null,
      showPrime:null,
      existingBagsModel:0,

      dropzoneOptions: {
              url: "/",
              thumbnailWidth: 100,
              addRemoveLinks: true,
              autoProcessQueue:false,
            },

      recaptchaScriptLoaded: false,
      alertMessage: null,



    };
  },
  mounted() {
    this.loadRecaptchaScript();
  },


  
  watch :{

    '$route': {
        immediate: true,
        deep: false, 
        handler(route) {
          this.plane = route.params.planeTitle;
          this.findPlaneByName()
        }
    },

    'selectedOptions.classic': function(newVal) {
        this.selectedOptions.prime = null;
      
    },
    'selectedOptions.prime': function(newVal) {
        this.selectedOptions.classic = null;      
    },



},

computed: {
    recaptchaSiteKey() {
        return this.$store.state.recaptchaSiteKey;
    },

    selectedOptionsType() {
        if (!this.selectedOptions) {
            return null;
        }

        const { classic, prime } = this.selectedOptions;

        if (classic === null && prime === null) {
            return null;
        }
        if (classic !== null && prime !== null) {
            return null;
        }
        if (classic !== null) {
            return 0;
        }
        if (prime !== null) {
            return 1;
        }
        return null;
    },


    selectedOptionsProposal() {
        switch (this.selectedOptionsType) {
            case 0:
                return this.selectedOptions.classic;
            case 1:
                return this.selectedOptions.prime;
            default:
                return null;
        }
    },

    isSelectedOptionsPharmacy() {
      return this.selectedOptions.classic === 0 || this.selectedOptions.prime === 0;
    }
},



methods: {


  findPlaneByName(){
        PlaneApi.findPlaneByName(this.plane).then(result=>{
            if(result){
                this.planeDTO = result
            }
        })
    },

  validateCampaignMedia(){
      if(this.existingBagsModel == null){
        this.alertMessage = this.$t('requestQuote.validation.existingBagsModelRequired');
        return false
      }

      if(this.selectedBagsColor == null){
        this.alertMessage = this.$t('requestQuote.validation.bagsColorQuantityRequired');
        return false
      }

      if(this.existingBagsModel == 0 && this.$refs.myVueDropzone.getAcceptedFiles()[0] == null   ){
        this.alertMessage = this.$t('requestQuote.validation.bagsModelRequired');
        return false
      }
      this.alertMessage= null

      this.scrollToTopWizard()
      return true
  },

  validateCampaignDuration(){
      if(!this.selectedCampaignDuration){
        this.alertMessage = this.$t('requestQuote.validation.campaignDurationRequired');
        return false
      }

      if(this.selectedCampaignDuration == 3 && ( this.requestQuote == null || this.requestQuote.customDuration == null  || this.requestQuote.customDuration.trim() == '' )   ){
        this.alertMessage = this.$t('requestQuote.validation.customCampaignDurationRequired');
        return false
      }
      this.alertMessage= null

      this.scrollToTopWizard()
      return true
  },

  validateSizeBags(){
      if(this.selectedSizeBags == null){
        this.alertMessage = this.$t('requestQuote.validation.sizeBagsRequired');
        return false
      }
      this.alertMessage= null

      this.scrollToTopWizard()
      return true
  },

  validateOption(){
      if(this.selectedOptionsType == null || this.selectedOptionsProposal == null){
        this.alertMessage = this.$t('requestQuote.validation.selectedOptionsRequired');
        return false
      }
      this.alertMessage= null

      this.scrollToTopWizard()
      return true
  },


  validateFields() {

      if (this.requestQuote.firstName == null ||  this.requestQuote.firstName.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.firstNameRequired');
        return false;
      }
      if (!this.requestQuote.lastName == null ||  this.requestQuote.lastName.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.lastNameRequired');
        return false;
      }
      if (this.requestQuote.email == null ||  this.requestQuote.email.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.validEmailRequired');
        return false;
      }
      if (this.requestQuote.phone == null ||  this.requestQuote.phone.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.phoneRequired');
        return false;
      }
      if (this.requestQuote.companyName == null ||  this.requestQuote.companyName.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.companyNameRequired');
        return false;
      }
      if (this.requestQuote.sectorActivity == null ||  this.requestQuote.sectorActivity.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.sectorActivityRequired');
        return false;
      }
      if (this.requestQuote.address == null ||  this.requestQuote.address.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.addressRequired');
        return false;
      }

      if (this.requestQuote.campaignDate == null ||  this.requestQuote.campaignDate.trim() == '') {
        this.alertMessage = this.$t('requestQuote.validation.campaignDateRequired');
        return false;
      }

      this.alertMessage= null

      this.scrollToTopWizard()
      return true;
    },

    scrollToTopWizard() {
      var elmnt = document.getElementById("wizard-quote");
      elmnt.scrollIntoView({ behavior: "smooth", block: "start" });
    },

  loadRecaptchaScript() {

    const recaptchaSiteKey = this.recaptchaSiteKey

    grecaptcha.ready(function() {
        grecaptcha.render('recaptcha-container', {
        'sitekey': recaptchaSiteKey,
        'badge': 'inline',
        'size': 'invisible'
    });
  });

  },  
  
    sendRequestQuote() {
      grecaptcha.ready(() => {
        grecaptcha.execute(this.recaptchaSiteKey, { action: 'submit' })
          .then(token => {

            const formData = new FormData();
            let modelBags = null;

            if (this.$refs.myVueDropzone) {
                modelBags = this.$refs.myVueDropzone.getAcceptedFiles()[0];
                if (modelBags) {
                    formData.append('modelBags', modelBags);
                }
            }


            const requestQuoteDTO = {
              firstName: this.requestQuote.firstName,
              lastName: this.requestQuote.lastName,
              email: this.requestQuote.email,
              phone: this.requestQuote.phone,
              companyName: this.requestQuote.companyName,
              sectorActivity: this.requestQuote.sectorActivity,
              address: this.requestQuote.address,

              customDuration: this.requestQuote.customDuration,
              sizeBags: this.selectedSizeBags,
              colorBags: this.selectedBagsColor,
              campaignDuration: this.selectedCampaignDuration,
              
              token: token,
              existingBagsModel: this.existingBagsModel,

              selectedOptionsType: this.selectedOptionsType,
              selectedOptions: Array.isArray(this.selectedOptionsProposal) 
                ? this.selectedOptionsProposal 
                : this.selectedOptionsProposal !== null 
                    ? [this.selectedOptionsProposal] 
                    : [],
              campaignDate: this.requestQuote.campaignDate,
              bagsPlane: this.plane,
              quantityBags: this.requestQuote.quantityBags,
            }

            this.isFinishDisabled = true;
            PlaneApi.sendRequestQuote(formData, requestQuoteDTO)
            .then(result => {
              if (result) {
                  setTimeout(() => {
                    this.$router.push({ name: "default" });
                  }, 3000);
              } else {
                this.isFinishDisabled = false;
              }
            })
            .catch((error) => {
              this.isFinishDisabled = false;
            });

          });
      });
    },

    isSelected(index, type) {
      if (type === 'classic') {
        return this.selectedOptions.classic === index;
      }
      if (type === 'prime') {
        return this.selectedOptions.prime === index;
      }
      return false;
    },

  isCampaignDurationSelected (index) {
      return this.selectedCampaignDuration == index;
  },
  
  isSizeBagsSelected (index) {
      return this.selectedSizeBags == index;
  },
  isBagsColorSelected (index) {
      return this.selectedBagsColor == index;
  },

  getColor(title) {
      if (title) {
        switch (title.toUpperCase()) {
        case "IRON":
          return "#137437"; // Dark, cool gray to represent iron
        case "BRONZE":
          return "#137437"; // Warm, reddish-brown to represent bronze
        case "SILVER":
          return "#137437"; // Slightly darker metallic silver for better distinction
        case "PALLADIUM":
          return "#137437"; // Light bluish-gray for palladium
        case "GOLD":
          return "#137437"; // Classic bright yellow-gold for gold
        case "PLATINUM":
          return "#137437"; //"#A6A6A6"; // Rich, dark metallic gray for platinum (more prominent)
        default:
          return "#000"; // Default color (white) for unknown metals
      }
    }
  },
}

  
};
</script>

<template>
  <Layout>


    <div class="bg-light text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0 pr-2 pl-2">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;"> 
            {{ $t('requestQuote.cardTitle') }} <span v-if="this.planeDTO" class="text-uppercase" :style="{ color: getColor(planeDTO.title) }">{{' / Pack '+ planeDTO.title}} <span v-if="planeDTO && planeDTO.quantityBags" style="font-size:1.3rem;">{{ ' (' + planeDTO.quantityBags + ') '}}</span> </span>
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            <strong>{{$t('concept.companyName')}}</strong> {{$t('concept.subTitle')}}
          </h6>
        </div>
      </div>
    </div>

    <div id="wizard-quote" class="p-4 bg-light" />


    <div class="bg-light">
      <div class="home-page-80-width justify-content-center pt-4 pb-4" style="opacity:0.95;">
        <div class="card h-100 w-100 login-card-border" style="border: 1px solid rgb(221, 221, 221); border-radius:8px;">
          <div class="card-body ">
            <form-wizard  stepSize="md" shape="tab" color="#137437" finish-button-text="Terminer" @on-complete="sendRequestQuote" >
              <div slot="prev" scope="props">
                <b-button variant="primary" class="mr-2 ml-2 mt-5 font-size-14 font-weight-bold d-flex align-items-center" >
                  <img alt="left" class="mr-2"  width="15px" src="@/assets/icons/double-left-w.svg" style="cursor: pointer;" />
                  {{ $t('requestQuote.prev') }}
                </b-button>                     
              </div>

              <div slot="next" scope="props">
                <b-button variant="primary" class="mr-2 ml-2 mt-5 font-size-14 font-weight-bold d-flex align-items-center" >
                  {{ $t('requestQuote.next') }}
                  <img alt="right" class="ml-2" width="15px" src="@/assets/icons/double-right-w.svg" style="cursor: pointer;" />
                </b-button>                     
              </div>

              <div slot="finish" scope="props">
              <b-button variant="primary" class="mr-2 ml-2 mt-5 font-size-14 font-weight-bold d-flex align-items-center" :disabled="isFinishDisabled">
                <img alt="right" class="mr-2" width="15px" src="@/assets/icons/check-circle-white.svg" style="cursor: pointer;" />

                Terminer
              </b-button>                     
              </div>


                  <template slot="step" slot-scope="props">
                  <wizard-step :tab="props.tab"
                  :transition="props.transition"
                  :index="props.index">
                  </wizard-step>
              </template>
              <tab-content :title="$t('requestQuote.tabs.tab1')" icon="info-icon" :before-change="validateFields">
               
                <!-- <h4 class="text-dark text-uppercase ">{{ $t('requestQuote.informations') }}</h4> -->


                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.firstName')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.firstName')"   
                              v-model="requestQuote.firstName" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>

                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.lastName')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.lastName')"   
                              v-model="requestQuote.lastName" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.email')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.email')"   
                              v-model="requestQuote.email" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>

                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.phone')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.phone')"   
                              v-model="requestQuote.phone" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.companyName')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.companyName')"   
                              v-model="requestQuote.companyName" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>

                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.sectorActivity')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.sectorActivity')"   
                              v-model="requestQuote.sectorActivity" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.address')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.address')"   
                              v-model="requestQuote.address" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>

                  <div v-if="this.plane == 'PERSONNALISE'" class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.quantityBags')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" :placeholder="$t('requestQuote.input.quantityBags')"   
                              v-model="requestQuote.quantityBags" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>

                  <div :class=" this.plane == 'PERSONNALISE' ? 'col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2' :'col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-2'">
                      <div class="text-dark font-size-16 pt-2 pb-2 "> Date de début souhaitée pour la campagne </div>

                    <b-form-group label-for="">
                        <b-form-datepicker
                          v-model="requestQuote.campaignDate"
                          :locale="$t('datPicker.locale')"
                          :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                          dark
                          reset-button
                          close-button
                          :label-reset-button="$t('datPicker.label-reset-button')"
                          :label-close-button="$t('datPicker.label-close-button')"
                          dropright
                          hide-header
                        ></b-form-datepicker>
                    </b-form-group>
                  </div>
                </div>

                

              
              <div class="text-secondary mt-4"> {{ $t('requestQuote.consentMessage') }}</div>
              
              <div v-show="alertMessage" class=" col-12 mt-4 text-danger text-right" show variant="danger">* {{this.alertMessage}}</div>

            
              </tab-content>
              <tab-content :title="$t('requestQuote.tabs.tab2')" icon="support-icon" :before-change="validateOption" >  
                <!-- <h4 class="text-dark text-uppercase ">{{ $t('requestQuote.supportTitle') }} <span class="text-primary font-weight-bold"> {{ $t('requestQuote.options') }}</span></h4> -->

                <div class="mt-5 hover-gamme p-2" @click="showClassic = true ; showPrime= false" style="cursor: pointer;" >
                  <div class="d-flex align-items-center">
                    <img alt="bassic badge" width="40px" src="@/assets/icons/bassic-badge.png"  />
                    <div class="ml-2 text-dark" >
                      <span class="font-weight-bold font-size-16">{{ $t('requestQuote.option') }}  
                        <span class="font-weight-bold ">{{ $t('requestQuote.classic') }}</span>
                      </span>
                      <div class="text-secondary font-size-14">{{ $t('requestQuote.optionClassicWithoutQRCode') }}</div>
                    </div>
                  </div>
                </div>

                <div class="row mt-4" v-if="showClassic">
                  <div v-for="(item, index) in options.classic" :key="'classic-' + index" class="col-12 col-md-6 text-center">
                    
                    <label :for="'gamme-classic-' + index" >
                      <div class="mb-3 mt-3">
                        <img 
                          :src="require(`@/assets/images/${item.image}.png`)" 
                          alt="image" 
                          width="auto" 
                          height="130px" 
                          :class="{'classic-image': true, 'classic-active-image': isSelected(index, 'classic')}"
                        />
                      </div>
                    </label>

                    <div class="text-dark font-size-14 font-weight-bold text-uppercase">{{ item.title }}</div>
                    <!-- <div class="text-secondary" v-html="item.description ? item.description.replace(/\n/g, '<br/>') : ''"></div> -->
                    
                    <div>
                      <b-form-radio 
                        :id="'gamme-classic-' + index" 
                        :name="'gamme-classic'" 
                        :value="index" 
                        v-model="selectedOptions.classic" 
                        class="image-radio-label--input text-center mt-2"
                      >
                      </b-form-radio >
                    </div>
                  </div>
                </div>

                <div class="mt-5  mb-4 hover-gamme p-2" @click="showClassic = false ; showPrime= true" style="cursor: pointer;" >
                  <div class="d-flex align-items-center">
                    <img alt="bassic badge" width="40px" src="@/assets/icons/premium-badge-gold.svg" />
                    <div class="ml-2" style="color:#beaa47 !important;">
                      <span class="font-weight-bold font-size-16">{{ $t('requestQuote.option') }}  
                        <span class="font-weight-bold  ">{{ $t('requestQuote.premium') }}</span>
                      </span>
                      <div class="text-secondary font-size-14" >{{ $t('requestQuote.extendedCommunication') }}</div>
                      <!-- <div class="text-secondary font-size-14 mt-1">{{ $t('requestQuote.description') }}</div> -->

                    </div>
                  </div>

                </div>

                <div v-if="showPrime" class="row mt-4">
                  <div v-for="(item, index) in options.prime" :key="'classic-' + index" class="col-12 col-md-6 text-center">
                    
                    <!-- Image and Label -->
                    <label :for="'gamme-prime-' + index" >
                      <div class="mb-3 mt-3">
                        <img 
                          :src="require(`@/assets/images/${item.image}.png`)" 
                          alt="image" 
                          width="auto" 
                          height="130px" 
                          :class="{'prime-image': true, 'prime-active-image': isSelected(index, 'prime')}"
                        />
                      </div>
                    </label>

                    <div class="font-weight-bold font-size-14 text-uppercase" style="color:#beaa47 !important;">{{ item.title }} & QR Code</div>
                    <!-- <div class="ext-secondary" v-html="item.description ? item.description.replace(/\n/g, '<br/>') : ''"></div> -->
                    
                    <!-- Checkbox -->
                    <div>
                      <b-form-radio 
                        :id="'gamme-prime-' + index" 
                        :name="'gamme-prime'" 
                        :value="index" 
                        v-model="selectedOptions.prime" 
                        class="image-radio-label--input text-center mt-2"
                      >
                      </b-form-radio >
                    </div>
                  </div>
                </div>

                <div v-show="alertMessage" class=" col-12 mt-4 text-danger text-right" show variant="danger">* {{this.alertMessage}}</div>

              </tab-content>
              <tab-content :title="$t('requestQuote.tabs.tab3')" icon="size-bags-icon" :before-change="validateSizeBags"  >  
                <h4 class="text-dark mt-5 mb-5">  {{ $t('requestQuote.sizeBags') }}</h4>
            


                <div class="row mt-4 mb-4">
                  <div v-for="item in isSelectedOptionsPharmacy ?sizeBagsPharmacy : sizeBags" :key="'classic-' + item.index" class=" text-center mb-4" :class="isSelectedOptionsPharmacy ? 'col-12 col-md-4' : 'col-12 col-md-6' ">
                    
                    <!-- Image and Label -->
                    <label :for="'size-bags-' + item.index">
                      <div class="mb-3">
                        <div class="text-dark" :class="{'size-bags': true, 'size-bags-active': isSizeBagsSelected(item.index)}">
                          {{ item.size }}
                        </div>
                        <div class="text-secondary text-uppercase mt-3" :class="{'name-active': isSizeBagsSelected(item.index)}">
                          {{item.description}}
                        </div>
                      </div>
                    </label>

                    <!-- Radio Button -->
                    <div>
                      <b-form-radio 
                        :id="'size-bags-' + item.index" 
                        :name="'size-bags'" 
                        :value="item.index" 
                        v-model="selectedSizeBags" 
                        class="text-center"
                      >
                      </b-form-radio>
                    </div>
                  </div>
                </div>
                <div v-show="alertMessage" class=" col-12 mt-4 text-danger text-right" show variant="danger">* {{this.alertMessage}}</div>

              </tab-content>

              <!-- <tab-content :title="$t('requestQuote.tabs.tab4')"  icon="calendar-icon" :before-change="validateCampaignDuration">
                <h4 class="text-dark mt-5 mb-5 ">{{ $t('requestQuote.campaignDuration') }}</h4>


                <div class="row mt-4 mb-4">
                  <div v-for="(item, index) in campaignDuration" :key="'classic-' + index" class="col-12 col-md-3 text-center mb-4">
                    
                    <label :for="'campaign-duration-' + index">
                      <div class="mb-3">
                        <div class="text-primary" :class="{'campaign-duration': true, 'campaign-duration-active': isCampaignDurationSelected(index)}">
                          {{ item }}
                        </div>

                        <div class="text-secondary text-uppercase mt-3" :class="{'name-active': isCampaignDurationSelected(index)}">
                          <div v-if="index == campaignDuration.length-1"  >  {{ $t('requestQuote.other') }} {{item}} </div>
                          <div v-else > {{item}} {{ $t('requestQuote.week') }} </div>
                        </div>

                      </div>
                    </label>

                    <div>
                      <b-form-radio 
                        :id="'campaign-duration-' + index" 
                        :name="'campaign-duration'" 
                        :value="index" 
                        v-model="selectedCampaignDuration" 
                        class="text-center"
                      >
                      </b-form-radio>
                    </div>
                  </div>

                  <div v-if="selectedCampaignDuration == campaignDuration.length-1" class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('requestQuote.label.customDuration')}} </div>
                      <b-form-group   class="font-weight-bold font-size-14"   >
                          <b-input-group   >
                              <b-form-input class="text-dark font-weight-bold font-size-16" type="number" min="0"  :placeholder="$t('requestQuote.input.customDuration')"   
                              v-model="requestQuote.customDuration" ></b-form-input>                              
                          </b-input-group>
                      </b-form-group>
                  </div>
                


                </div>
                <div v-show="alertMessage" class=" col-12 mt-4 text-danger text-right" show variant="danger">* {{this.alertMessage}}</div>

              </tab-content> -->

              <tab-content :title="$t('requestQuote.tabs.tab5')"  icon="model-icon" :before-change="validateCampaignMedia">
                <h4 class="text-dark mb-4 mt-5">{{ $t('requestQuote.bagsModel') }}</h4>

                <div class="ml-4">
                  <b-form-radio-group v-model="existingBagsModel" class="text-left mt-3 mb-3">
                    <div class="mt-4">
                    <b-form-radio :value="0">
                      <span class="font-size-14" :class="existingBagsModel === 0 ? 'text-primary font-weight-bold' : 'text-dark'">
                        {{ $t('requestQuote.IHaveModel') }}
                      </span>
                    </b-form-radio>
                  </div>
                  <div class="mt-4">
                    <b-form-radio :value="1">
                      <span class="font-size-14" :class="existingBagsModel === 1 ? 'text-primary font-weight-bold' : 'text-dark'">
                        {{ $t('requestQuote.IDontHaveModel') }}
                      </span>
                    </b-form-radio>
                  </div>
                  <div class="mt-4">
                    <b-form-radio :value="2">
                      <span class="font-size-14" :class="existingBagsModel === 2 ? 'text-primary font-weight-bold' : 'text-dark'">
                        {{ $t('requestQuote.INeedHelp') }}
                      </span>
                    </b-form-radio>
                  </div>
                  </b-form-radio-group>
                </div>

              <h4 class="text-dark mt-5 ">{{ $t('requestQuote.quantityColor') }}</h4>

              <div class="row mt-4 mb-4">
                  <div v-for="(item, index) in bagsColor" :key="'classic-' + index" class="col-12 col-md-3 text-center mb-4">
                    
                    <!-- Image and Label -->
                    <label :for="'bags-color-' + index">
                      <div class="mb-3">
                        <div class="text-primary" :class="{'bags-color': true, 'bags-color-active': isBagsColorSelected(index)}">
                          {{ item }}
                        </div>

                        <div class="text-secondary text-uppercase mt-3" :class="{'name-active': isBagsColorSelected(index)}">
                          <div > {{item}} {{ $t('requestQuote.color') }} </div>
                        </div>

                      </div>
                    </label>

                    <!-- Radio Button -->
                    <div>
                      <b-form-radio 
                        :id="'bags-color-' + index" 
                        :name="'bags-color'" 
                        :value="index" 
                        v-model="selectedBagsColor" 
                        class="text-center"
                      >
                      </b-form-radio>
                    </div>
                  </div>
                </div>

                <div v-if="existingBagsModel != 2">
                  <h4 class="text-dark ml-2 ">{{ $t('requestQuote.importModel') }}</h4>

                  <div class="col-12 text-center">
                      <b-form-group class="text-dark font-weight-bold" :disabled="existingBagsModel == 1"  >
                          <vue2Dropzone class="m-0 p-0 m-md-2 p-md-1" id="dropzone" ref="myVueDropzone" maxFileSizeInMB="1" maxNumberOfFiles="1" :use-custom-slot="true" :options="dropzoneOptions">
                              <div class="dropzone-custom-content text-center p-3">
                              <img   alt=""  width="80px"  src="@/assets/icons/cloud-upload.svg"  />  
                                  <h4 class="mb-0">{{ $t('requestQuote.dropImage') }}</h4>
                                  <h5 class="text-warning font-size-9 text-Center mt-1" >{{ $t('requestQuote.imageSize') }} </h5>
                              </div>
                          </vue2Dropzone>
                      </b-form-group>     
                  </div>

                </div>




                <div v-show="alertMessage" class=" col-12 mt-4 text-danger text-right" show variant="danger">* {{this.alertMessage}}</div>

              </tab-content>
            </form-wizard>


            <div class="row mt-5">
              <div class="col-12 ">
                  <div  id="recaptcha-container"/>
              </div>
            </div>

          </div>
        </div>


        
        
      </div>
    </div>
  </Layout>
</template>


<style>


#recaptcha-container {
  position: relative;
  width: 100%; 
  height: 100%;
  display: flex;
  justify-content: flex-end; 
  align-items: center;
  opacity: 0.3;
}

#recaptcha-container .grecaptcha-badge {
  display: block !important;
  position: relative;
  margin-right: 10px;
}

.vue-form-wizard .wizard-icon-circle.tab_shape {
    width: 100%;
    min-width: 100px;
    height: 40px;
    border: none;
    background-color: #ddd;
    border-radius: 0;
}

.info-icon {
  background: url('../../../assets/icons/info-circle-w.svg') no-repeat center;
  background-size: contain;
  display: flex;
  align-self: center;
  width: 30px;
  height: 30px;
}

.support-icon {
  background: url('../../../assets/icons/menu-dots-w.svg') no-repeat center;
  background-size: contain;
  display: inline-block;
  align-self: center;
  width: 30px;
  height: 30px;
}

.size-bags-icon {
  background: url('../../../assets/icons/bag-w.svg') no-repeat center;
  background-size: contain;
  display: inline-block;
  align-self: center;
  width: 30px;
  height: 30px;
}
.calendar-icon {
  background: url('../../../assets/icons/calendar-w.svg') no-repeat center;
  background-size: contain;
  display: inline-block;
  align-self: center;
  width: 30px;
  height: 30px;
}
.model-icon {
  background: url('../../../assets/icons/image-w.svg') no-repeat center;
  background-size: contain;
  display: inline-block; 
  align-self: center;
  width: 30px;
  height: 30px;
}

</style>


<style scoped>

.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437;
  border: none;
  margin: auto;
}

.classic-image{
  overflow: hidden;
  padding: 10px;
  border: 3px solid #ddd;
  border-radius: 6%;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.classic-image:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.classic-active-image {
  border: 3px solid #137437 !important;
}


.prime-image{
  overflow: hidden;
  padding: 10px;
  border: 3px solid #beaa47 !important;
  border-radius: 6%;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px #beaa47;
}

.prime-image:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px #beaa47;
}

.prime-active-image {
  border: 3px solid #137437 !important;
}


.campaign-duration{
  font-size: 70px;
  overflow: hidden;
  padding: 15px 40px 15px 40px ;
  border: 5px solid #cacaca;
  border-radius: 6%;
  transition: all 0.3s ease;

}

.campaign-duration-active {
  border: 5px solid #137437 !important;
}


.size-bags{
  font-size: 40px;
  overflow: hidden;
  padding: 15px 40px 15px 40px ;
  border: 5px solid #cacaca;
  border-radius: 6%;
  transition: all 0.3s ease;

}

.size-bags-active {
  border: 5px solid #137437 !important;
}

.bags-color{
  font-size: 70px;
  overflow: hidden;
  padding: 15px 40px 15px 40px ;
  border: 5px solid #cacaca;
  border-radius: 6%;
  transition: all 0.3s ease;

}

.bags-color-active {
  border: 5px solid #137437 !important;
}
.name-active {
  color:#137437 !important;
  font-weight: bold  !important;
}

.hover-gamme {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-gamme:hover {
  background-color: #f3f2ee;
  border-radius: 10px;
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

::v-deep .vue-dropzone .dz-message{
  margin: 0px !important;
}
</style>

